import React, { useState, useRef, useEffect } from 'react'

import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import './styles/home.scss'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import ship from '../assets/img/ship.png'

gsap.registerPlugin(ScrollTrigger);

function Home(themeData) {

  const shipRef = useRef(null);

  useEffect(() => {
    document.title = 'Home • IBIS GlobaLink Co., Ltd..';
  }, []);

  useEffect(() => {
    document.title = 'Home • IBIS GlobaLink Co., Ltd..';

    // Animate ship on scroll
    gsap.to(shipRef.current, {
      x: '-200vw',
      ease: 'none',
      scrollTrigger: {
        trigger: '.landing',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }, []);
  
  return (
    <ThemeProvider theme={themeData.theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />
      <div id="home">
        <section className="landing">
          <img ref={shipRef} src={ship} alt="Ship" />
          <div className="wrapper">
            <div className="flex flex-column">
              <span>
                Connecting Japan <br /> and the World <br /> through Logistics.
              </span>
            </div>
          </div>
        </section>

        <section className="home section-bottom">
          <div className="wrapper">
            <div className="flex flex-column">
              <span className="title">
                Let us solve your logistics problems.
              </span>
            </div>
          </div>

          <div className="wrapper">
            <div className="type-container">
              <span className="type">
                IBIS GlobaLink is a logistics service company
                specializing in all kinds of ship-related products.
              </span>
            </div>
          </div>

          <div className="wrapper">
            {/* <div className='type-container'>
              ff
            </div> */}

            <div className="home-content">

              <div class="parent">
                <div class="div1 hide-block">
                <lord-icon
                    src="https://cdn.lordicon.com/rpviwvwn.json"
                    trigger="loop"
                    delay="2000"
                    colors="primary:#ef8746,secondary:#48a0df"
                    style={{ width: "200px", height: "200px" }}>
                </lord-icon>
                </div>
                <div class="div2 bg-orange box1">
                  <span className='text1'>As the global economy undergoes a period of major change, the needs of our customers are becoming increasingly diverse and complex.</span>
                </div>
                <div class="div3 bg-blue box2">
                  <span>In order to provide more advanced services, specialist knowledge and experience are indispensable. <br/> <br/> The export of ship's equipment requires advanced knowledge of special products and dangerous parts. In addition, for the safe operation of ships sailing around the world, speedy and accurate response is indispensable. In this respect, we are a group of companies that has been supplying ship spare parts for more than 40 years.</span>
                </div>
                <div class="div4 hide-block">
                  <lord-icon
                      src="https://cdn.lordicon.com/rrbmabsx.json"
                      trigger="loop"
                      delay="2000"
                      colors="primary:#ef8746,secondary:#48a0df"
                      style={{ width: "200px", height: "200px" }}>
                  </lord-icon>
                </div>
                <div class="div5 hide-block">
                  <lord-icon
                      src="https://cdn.lordicon.com/prjriwwv.json"
                      trigger="loop"
                      delay="2000"
                      colors="primary:#ef8746,secondary:#48a0df"
                      style={{ width: "200px", height: "200px" }}>
                  </lord-icon>
                </div>
                <div class="div6 bg-orange box3">
                  <span>We are a group that can fully utilize our vast experience and knowledge to provide professional solutions to logistics problems. We provide the best logistics services to the shipping industry by maximizing the use of all available logistics means by land, sea, and air, as well as our overseas network, to ensure prompt export procedures.</span> 
                </div>
                <div class="div7 bg-blue box4">
                  <span className='text4'>IBIS GlobaLink aims to achieve 100% customer satisfaction under the slogan “Connecting Japan and the world through logistics”.</span>
                </div>
                <div class="div8 hide-block">
                  <lord-icon
                      src="https://cdn.lordicon.com/pfvaixkr.json"
                      trigger="loop"
                      delay="2000"
                      colors="primary:#ef8746,secondary:#48a0df"
                      style={{ width: "200px", height: "200px" }}>
                  </lord-icon>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    </ThemeProvider>
  );
}

export default Home;